import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import { combineRules } from 'fela';
import deprecate from './_deprecate';
export default function FelaComponentFactory(createElement, RendererContext, FelaTheme) {
  function FelaComponent(_ref) {
    var children = _ref.children,
        _ref$as = _ref.as,
        as = _ref$as === undefined ? 'div' : _ref$as,
        style = _ref.style,
        customClass = _ref.customClass,
        rule = _ref.rule,
        render = _ref.render,
        otherProps = _objectWithoutProperties(_ref, ['children', 'as', 'style', 'customClass', 'rule', 'render']); // TODO: remove in 11.0.0


    deprecate(customClass !== undefined, 'The `customClass` prop in FelaComponent is deprecated. It will be removed in react-fela@11.0.0.\nPlease resolve class names manually in your render function. See http://fela.js.org/docs/api/bindings/fela-component');
    deprecate(rule !== undefined, 'The `rule` prop in FelaComponent is deprecated. It will be removed in react-fela@11.0.0.\nPlease always use `style` instead. See http://fela.js.org/docs/api/bindings/fela-component', function () {
      style = rule;
    });
    deprecate(render !== undefined, 'The `render` prop in FelaComponent is deprecated. It will be removed in react-fela@11.0.0.\nPlease always use `children` instead. See http://fela.js.org/docs/api/bindings/fela-component');

    var renderFn = function renderFn(renderer) {
      if (renderer.devMode && style == null) {
        // eslint-disable-next-line no-console
        console.warn('"FelaComponent" is being rendered without a style prop\nIf all you need is access to theme, try using "FelaTheme" or the "useFela" hook instead');
      }

      return createElement(FelaTheme, undefined, function (theme) {
        // TODO: could optimize perf by not calling combineRules if not necessary
        var className = renderer.renderRule(combineRules(style), _extends({}, otherProps, {
          theme: theme
        })); // TODO: remove in 11.0.0

        var cls = customClass ? customClass + ' ' + className : className;

        if (render instanceof Function) {
          return render({
            className: cls,
            children: children,
            theme: theme,
            as: as
          });
        }

        if (typeof render === 'string') {
          return createElement(render, {
            className: cls
          }, children);
        }

        if (children instanceof Function) {
          return children({
            className: cls,
            theme: theme,
            as: as
          });
        }

        return createElement(as, {
          className: cls
        }, children);
      });
    };

    return createElement(RendererContext.Consumer, undefined, renderFn);
  }

  return FelaComponent;
}